import React from 'react';
import {useIntl} from 'react-intl';
import classNames from 'classnames';
import QuestionText from '../../questions/QuestionText.jsx';
import {getMessageValue} from '../../../i18n/messageUtil';
import IgniteDropdownSearch from '@ignitesales/react-dropdown-search';
import {QuestionTypeViewPropTypes} from '../../../shapes/index.mjs';
import {useText} from '../../TextContext';

const DropdownSearch = props => {
  const {className, valueChanged, question, value: {value = {}} = {}} = props;

  const intl = useIntl();
  const textContext = useText();
  const answers = question.answers;
  const currentValue = value && value.length > 0 ? value[0] : value;
  const selectedOption = answers.find(a => a.key === currentValue);
  const classes = classNames(className, {
    'dropdown-search': true,
  });

  const options = answers.map((option, index) => {
    return {
      label:
        textContext?.[`${question.appkey}.${option.key}`] ||
        intl.formatMessage({id: `${question.appkey}.${option.key}`}),
      value: option.key || index,
    };
  });

  const onChange = v => {
    valueChanged(v);
  };

  const message =
    getMessageValue(intl.locale, `${question.appkey}.input.placeholder`) || intl.formatMessage({id: 'pleaseSelect'});

  return (
    <section className={classes}>
      <QuestionText question={question} />
      <div className="dropdown-search__container">
        <IgniteDropdownSearch
          onChange={onChange}
          options={options}
          value={selectedOption ? selectedOption.key : null}
          placeholder={message}
          noOptionsPlaceholderFn={v => `'${v}' is not listed`}
        />
      </div>
    </section>
  );
};

DropdownSearch.propTypes = QuestionTypeViewPropTypes;

export default DropdownSearch;
